module.exports = __webpack_public_path__ + "static/media/minoan_text_08.090cc467.jpg";